import React from 'react';
import { PropTypes } from 'prop-types';
import Image from 'next/legacy/image';

import useIsMobile from 'hooks/useIsMobile';

import Button from 'components/designSystem/Button/Button';

import Grid from 'components/designSystem/Grid/Grid.tsx';
import { GET_THE_APP_URL } from '@chownow/cn-web-utils/paths';

import styles from './DinerModule.module.scss';

import dinerImage from './Img-Impact.jpg';

function DinerModule({ handleScroll }) {
  const isMobile = useIsMobile();
  function handleGetTheAppClick() {
    return isMobile ? window.open(GET_THE_APP_URL, '_blank') : handleScroll();
  }

  return (
    <section className={styles.dinerSection}>
      <Grid container>
        <Grid sm={4} md={8} mdOffset={3} lg={8} lgOffset={3}>
          <p className={styles.headline}>
            Unlike other apps, ChowNow is 100% commission-free with no hidden fees. We help
            restaurants save money, so they can share the savings with you.
          </p>
        </Grid>
        {!isMobile && <Grid sm={4} md={12} lg={12} className={styles.border} />}
        <Grid sm={4} md={6} lg={6}>
          <div className={styles.gridOverflow}>
            <Image
              src={dinerImage}
              className={styles.dinerImage}
              alt="ChowNow App"
              height={634}
              width={634}
              layout="responsive"
              placeholder="blur"
            />
          </div>
        </Grid>
        <Grid sm={4} md={6} lg={6}>
          <div className={styles.contentContainer}>
            <p className={styles.dinerTitle}>Not your typical ordering app</p>
            <p className={styles.dinerContent}>
              Most apps charge restaurants 20-40% in commissions—not ChowNow. With us, restaurants
              keep 100% of their profits, so they can continue to grow and serve your community.
            </p>
            <div className={styles.btnDesktop}>
              <Button onClick={handleGetTheAppClick} size="large">
                Get the App
              </Button>
            </div>
            <div className={styles.btnDevice}>
              <Button onClick={handleGetTheAppClick}>Get the App</Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </section>
  );
}

DinerModule.propTypes = {
  handleScroll: PropTypes.func.isRequired,
};

export default DinerModule;
